 document.addEventListener('DOMContentLoaded', function() {
            // Tab functionality
            const tabs = document.querySelectorAll('.tab');
            const tabPanes = document.querySelectorAll('.tab-pane');
            
            tabs.forEach(tab => {
                tab.addEventListener('click', function() {
                    // Remove active class from all tabs and panes
                    tabs.forEach(t => t.classList.remove('active'));
                    tabPanes.forEach(pane => pane.classList.remove('active'));
                    
                    // Add active class to clicked tab
                    this.classList.add('active');
                    
                    // Show corresponding tab pane
                    const tabId = this.getAttribute('data-tab');
                    document.getElementById(tabId).classList.add('active');
                });
            });
            
            // Dropdown functionality
            const dropdownHeaders = document.querySelectorAll('.dropdown-header');
            
            dropdownHeaders.forEach(header => {
                header.addEventListener('click', function() {
                    const dropdown = this.parentElement;
                    dropdown.classList.toggle('active');
                });
            });
        });


//For dropdown 
document.addEventListener("DOMContentLoaded", function () {
  function setupYearFilter(filterId, containerSelector) {
    const filter = document.getElementById(filterId);
    if (!filter) return;

    const container = filter.closest(containerSelector);
    const boxes = container.querySelectorAll(".drop-box");

    filter.addEventListener("change", function () {
      const selectedYear = this.value;
      boxes.forEach(box => {
        box.style.display = (box.dataset.year === selectedYear) ? "block" : "none";
      });
    });
  }

  // Initialize each dropdown separately
   setupYearFilter("yearFilter", ".dropdown-quarter");
  setupYearFilter("yearFilter1", ".dropdown");  // Subsidiary
  setupYearFilter("yearFilter2", ".dropdown"); 
  setupYearFilter("yearFilter3", ".dropdown-quarter");
  setupYearFilter("yearFilter4", ".dropdown");  // Subsidiary
  setupYearFilter("yearFilter5", ".dropdown"); 
  setupYearFilter("yearFilter6", ".dropdown-quarter");
  setupYearFilter("yearFilter7", ".dropdown");  // Subsidiary
   // Financial Highlights
});
 


